import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sign-in-container" }
const _hoisted_2 = {
  id: "firebaseui-auth-container",
  ref: "firebaseui-auth-container"
}

import { onMounted, onUnmounted, ref } from 'vue'
import { authCompat } from "@/firebase"
import { authSettings } from "@/firebase/config"
import firebase from 'firebase/compat/app'
import * as firebaseui from "firebaseui"
import "firebaseui/dist/firebaseui.css"


export default /*@__PURE__*/_defineComponent({
  __name: 'SignInForm',
  setup(__props) {

let ui: firebaseui.auth.AuthUI | null = null
const captchaVerified = ref(false)

// Глобальная функция для обработки верификации reCAPTCHA
// @ts-ignore
window.onCaptchaVerify = () => {
  console.log('reCAPTCHA verified')
  captchaVerified.value = true
}

onMounted(() => {
  const uiConfig = {
    ...authSettings,
    signInOptions: [
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: 'ME',
        whitelistedCountries: ['ME'],
        loginHint: '+382',
        recaptchaParameters: {
          size: 'invisible',
          badge: 'bottomleft' // Возвращаем к исходному значению для лучшей совместимости с мобильными устройствами
        }
      }
    ],
    // Предотвращаем перезагрузку страницы
    signInFlow: 'popup',
    // Отключаем редирект после аутентификации
    signInSuccessUrl: undefined,
    callbacks: {
      signInSuccessWithAuthResult: (authResult: any) => {
        console.log('Auth result:', authResult)
        // Возвращаем false, чтобы предотвратить перенаправление
        return false
      },
      signInFailure: (error: firebaseui.auth.AuthUIError) => {
        console.error('Auth error:', error)
        // Обрабатываем ошибки аутентификации
        return Promise.resolve()
      },
      // Добавляем обработчик для предотвращения перезагрузки на мобильных устройствах
      uiShown: () => {
        // Находим все формы в контейнере FirebaseUI
        const forms = document.querySelectorAll('#firebaseui-auth-container form')
        forms.forEach(form => {
          form.addEventListener('submit', (e) => {
            // Предотвращаем стандартную отправку формы
            e.preventDefault()
          })
        })
      }
    }
  }

  ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(authCompat)
  ui.start("#firebaseui-auth-container", uiConfig)
})

onUnmounted(() => {
  if (ui) {
    ui.delete()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512)
  ]))
}
}

})